import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import { useTranslation } from 'react-i18next';
// import travelimg from '../tr.png';
import { Container, Form, Row, Col, Card, Button, CardBody } from "react-bootstrap";
import Cookies from 'js-cookie';
import SignatureCanvas from 'react-signature-canvas';
const { config } = require('../../api/api');



function MedicalHealthQuestions() {

  const base_url = config.baseURL;

  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';
  const signatureRef = useRef();

  const { t } = useTranslation();

  const openDoc = (file) => {
    fetch(base_url + '/getdhofarpolicydocument?file=' + file)
      .then(r => r.json())
      .then(d => { if (d.data) window.open(d.data, '_blank'); })
      .catch(() => {});
  };

  const [formData, setFormData] = useState({
    insurancetype: '',
  });
  const [loading, setLoading] = useState(false);



  const handleqOptionChange = (event) => {

  };
  const [quotationData, setQuotationData] = useState(null);

  // const [bacsicinfomation, setapplicationData] = useState('');
  // const [preminum, setpremium] = useState('');
  // const [benefitys, setaddbenefity] = useState('');
  // const [personalin, setpersonalinfo] = useState({});

  const [questionList, setQuestionList] = useState();

  const [questionsData, setQuestionsData] = useState([{
    english: '',
    arabic: '',
    key: '',
    accepted_answer: '',
    isChecked: '',
    isChecked_answer: '',
    details: ''
  }]);


  const [selectedValue, setSelectedValue] = useState('Yes');

  const handleChanges = (e) => {
    setSelectedValue(e.target.value);
  };
  function handleRadioChange(index, isChecked) {
    const updatedQuestionsData = [...questionsData];
    updatedQuestionsData[index] = {
      ...updatedQuestionsData[index],
      isChecked,
      isChecked_answer: isChecked ? "Yes" : "No"
    };
    setQuestionsData(updatedQuestionsData);
  }

  function handleDetailsChange(index, details) {

    const updatedQuestionsData = [...questionsData];
    updatedQuestionsData[index] = {
      ...updatedQuestionsData[index],
      details
    };
    setQuestionsData(updatedQuestionsData);
  }

  const [isSignatureEmpty, setIsSignatureEmpty] = useState(true);


  const clearSignature = () => {
    signatureRef.current.clear();
    setIsSignatureEmpty(true); // Disable button after clearing
  };
  const handleSignature = () => {
    if (!signatureRef.current.isEmpty()) {
      setIsSignatureEmpty(false); // Enable button when signature is drawn
    }
  };
  const [isChecked, setIsChecked] = useState(false);
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };

  const [isChecked1, setIsChecked1] = useState(false);
  const handleCheckboxChange1 = (event) => {
    setIsChecked1(event.target.checked);
  };

  const [isChecked2, setIsChecked2] = useState(false);
  const handleCheckboxChange2 = (event) => {
    setIsChecked2(event.target.checked);
  };











  const handleSubmit = async (event) => {

    event.preventDefault();
    setLoading(true);

    event.preventDefault();
    window.location.href = '/';



  };
  const [dhofarData, setDhofarData] = useState(false);
  const [age, setAge] = useState(null);
  useEffect(() => {


    const storedDhofarString = Cookies.get('medicalAffordableData'); //sessionStorage.getItem('userData')
    debugger
    if (storedDhofarString !== undefined) {
      const storedDhofar = JSON.parse(storedDhofarString);
      setDhofarData(storedDhofar);
    }
    else {
      // alert("token expired");
      // window.location.href='/';
    }

  }, []);


  const [vendorKey, setVendorkey] = useState('');

  useEffect(() => {

    const postvData = { organization_name: "Superjet" };
    debugger

    if (vendorKey === '' || vendorKey === null || vendorKey === undefined) {


      fetch(base_url + '/create_organization', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(postvData),
      })
        .then(response => response.json())
        .then(data => {
          setVendorkey(data.result[0].vendor_key);
        })
        .catch(error => {
          console.error('Error posting data:', error);
        });


    }
  }, [vendorKey]);

  const [buttonDisabled, setButtonDisabled] = useState(false);
  const postData = { token: dhofarData };
  // const today = new Date().toISOString().split('T')[0];
  const today = new Date();
  const maxDate = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate() + 1).toISOString().split('T')[0];


  const [dobValue, setdobValue] = useState('');
  const handledobChange = (event) => {
    const selectedDob = event.target.value;
    setdobValue(event.target.value);

    const dobDate = new Date(selectedDob);
    const today = new Date();
    let calculatedAge = today.getFullYear() - dobDate.getFullYear();
    const monthDiff = today.getMonth() - dobDate.getMonth();

    // Adjust age if the current date is before the user's birthday in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
      calculatedAge--;
    }

    setAge(calculatedAge);
  };

  // const [selectedgenderOption, setSelectedgenderOption] = useState(null);
  // const [selectedgenderOptionid, setSelectedgenderOptionid] = useState(null);
  // const handlegenderChange = (event) => {
  //   setSelectedgenderOptionid(event.target.options[event.target.selectedIndex].id);
  //   setSelectedgenderOption(event.target.value);
  // };

  // const [selectedmaritalOption, setSelectedmaritalOption] = useState(null);
  // const [selectedmaritalOptionid, setSelectedmaritalOptionid] = useState(null);
  // const handlemaritalChange = (event) => {
  //   setSelectedmaritalOptionid(event.target.options[event.target.selectedIndex].id);
  //   setSelectedmaritalOption(event.target.value);
  // };
  //getgender

  const [questions, setquestionsValue] = useState([]);

  useEffect(() => {
    if (vendorKey !== '') {
      const fetchQuestions = async () => {
        try {
          debugger
          const response = await fetch( base_url + '/get_ahc_questions', {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${vendorKey}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData),
          });

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          setQuestionList(data.result.data);
          var questionsLists = data.result.data;

          questionsLists = questionsLists.map(question => ({
            english: question.English,
            arabic: question.Arabic,
            key: question.key,
            accepted_answer: question.accepted_answer,
            isChecked: '',
            details: '',
            isChecked_answer: ''
          }));
          const getQuestions=sessionStorage.getItem("medicalquestionvalue");
          
          if(getQuestions!==undefined&&getQuestions!==null&&getQuestions!==""){
           const homeQuestions =JSON.parse(getQuestions);
          Object.keys(homeQuestions).forEach((prop)=>{
            const currentQuestion = questionsLists.find(question => question.key === prop);
               if (currentQuestion) {
               const updatedQuestionsData = [...questionsLists];
               const updatedQuestion = { ...currentQuestion, isChecked: homeQuestions[prop]==="Yes" ? true : false , isChecked_answer: homeQuestions[prop] };
               updatedQuestionsData[questionsLists.indexOf(currentQuestion)] = updatedQuestion;
               questionsLists = updatedQuestionsData;
  }

  });
          setQuestionsData(questionsLists);
        }
        else{
          setQuestionsData(questionsLists);
          }
        if(getQuestions!==undefined){
           const checkbox =JSON.parse(getQuestions);
           setIsChecked(checkbox.checkbox_checked);
          }
          
          // setQuestionsData(questionsLists);
        } catch (error) {
          console.error('Error fetching occupations:', error);
        }
      };

      fetchQuestions();
    }
  }, [vendorKey]);

  debugger
  // console.log(questions.map(question.index))
  console.log(questions)

  //getmaritalstatus

  // const handleSubmit = async (event) => {

  //   event.preventDefault();

  //   if (selectedOption === null) {
  //     alert('Please choose plan');
  //     return false;
  //   }
  // }

  const api_headers = {
    'Authorization': 'Bearer ' + vendorKey,
    'Content-Type': 'application/json' // Ensure you're sending JSON
  }


const [amount, setAmountValue] = useState('');
const [policy, setPolicyValue] = useState('');











  const handleQotation = async (event) => {

    

  const bacsicinfojson = sessionStorage.getItem('affordablebasicinfo');
    const basicinfo = JSON.parse(bacsicinfojson);

    const personalinfojson = sessionStorage.getItem('medicalaffordablepage');
    const personalinfo = JSON.parse(personalinfojson);

    function formatDOB(dob) {
      const date = new Date(dob);
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
  }

    debugger

    var quotation_data =
    {
      "token": dhofarData,
      "cover_type": "Affordable Health Cover Plan",
      "application_type": "domestic",
      "plan_type": "Affordable Cover",
      "plan": "Affordable Cover",
      "network_type": "Affordable Cover",
      "nationality": personalinfo.nationality,
      "civil_id": personalinfo.civilid,
      "personalInformation": {
        "sponsorName": personalinfo.sponsorName,
        "sponsor_type": personalinfo.sponsor_type,
        "sponsor_id": personalinfo.sponsor_id,
        "fullName": personalinfo.fullName,
        "email": personalinfo.email,
        "mobileNumber": personalinfo.mobilenumber,
        "dob": formatDOB(basicinfo.dob),
        "resident_location": personalinfo.Residential_Location,
        "gender": basicinfo.basicinfo_gender_detail.toLowerCase(),
        "is_married": basicinfo.basicinfo_marital_status_detail.toLowerCase() === "single" ? 'no' : 'yes',
        "height": personalinfo.height,
        "weight": personalinfo.weight,
        "occupation": personalinfo.occupation,
        "passport": personalinfo.passportnumber,
      },
    };
    if (vendorKey !== '') {
      // const fetchPolicy = async () => {
      try {


        const dd = await fetch( base_url + '/get_ahc_quotations', {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${vendorKey}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(quotation_data),
        });

        if (!dd.ok) {
          throw new Error('Network response was not ok');
        }
        debugger

        const data = await dd.json();

        setAmountValue(data.result.data.amount);
        sessionStorage.setItem("medicalamount", JSON.stringify(data.result.data.amount))
        // await handlePolicy(data.result.data.amount)
        var questionvalue = questionsData.reduce((acc, q) => {
          acc[q.key] = q.isChecked_answer;
          return acc;
        }, { signature: signatureRef.current.toDataURL() });
        sessionStorage.setItem('medicalquestionvalue', JSON.stringify(questionvalue))
        const signatureData=signatureRef.current.toDataURL();
        sessionStorage.setItem("medicalSignature",signatureData);
        window.location.href = '/medicalhealth-policy';
      } catch (error) {
        console.error('Error fetching occupations:', error);
      }
      // };


    }
  };




  





  return (
    <Fragment>

      <div className="header_section1">

        <Navbar />


        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{(lnstr === 'en') ? 'Please answer the following' : 'الرجاء الإجابة على ما يلي\n'}</h3>
          </div>
        </div>


      </div>


      <div className="features_section">
        <div className="container">

          <div className="row">

            <Col md={3}></Col>

            <Col md={6} className="myforms my-5">


              {questionsData.map((question, index) => (
                <div key={index}>
                  <p>{index+1}.{question.english}</p>
                  <div className="custom-radio" style={{color:'#3fd2f2'}}>
                    <input
                      type="radio"
                      id={`yes-${index}`}
                      name={`option-${index}`}
                      value="Yes"
                      checked={question.isChecked === true && question.isChecked_answer==="Yes"}
                      onChange={() => handleRadioChange(index, true)}
                    />
                    <label htmlFor={`yes-${index}`}>Yes</label>

                    <input
                      type="radio"
                      id={`no-${index}`}
                      name={`option-${index}`}
                      value="No"
                      checked={question.isChecked === false&& question.isChecked_answer==="No"}
                      onChange={() => handleRadioChange(index, false)}
                    />
                    <label htmlFor={`no-${index}`}>No</label>
                  </div>
                  <br />
                  {question.isChecked_answer != '' && question.accepted_answer !== question.isChecked_answer && (
                    <div className='col-md-12'>
                      <textarea
                        style={{
                          height: '100px',
                          width: '100%'
                        }}
                        value={question.details || ''} // Ensure there's a default value
                        onChange={(e) => handleDetailsChange(index, e.target.value)}
                        placeholder="Please provide more details"
                      />
                    </div>
                  )}
                </div>
              ))}


              {lnstr=="en"? <b>Please put your signature here</b>:<b>من فضلك وقع هنا</b>}<br />

              <SignatureCanvas
                ref={(ref)=>{
                  signatureRef.current=ref;
                  const  storedSignature=sessionStorage.getItem("medicalSignature");
                  if(storedSignature && ref){
                    ref.clear();
                    ref.fromDataURL(storedSignature);
                    setIsSignatureEmpty(false);
                  }

                }}
                penColor="black"
                canvasProps={{ width: 340, height: 200, className: 'sigCanvas' }}
                style={{ border: '1px solid #ccc', backgroundColor: 'white' }} // Ensure background is white
                onEnd={handleSignature} // Detect when drawing ends
              />
              <div>
                <button type="button"
                  style={{ backgroundColor: !isSignatureEmpty ? '#1D3561' : 'grey', borderColor: '#1D3561' }}
                  className="btn btn-primary rounded-pill text-white my-3 py-1 " onClick={async () => {
                    clearSignature();
                  }}
                  disabled={isSignatureEmpty}
                >
                   {t("Clear Signature")}
                </button>
              </div>



              

            <p ><input type="checkbox" checked={isChecked}
              onChange={handleCheckboxChange} name="note" />
              {lnstr=="en"?"I have seen and have clearly understood the coverage and exclusions of the policy as listed in the  ":"لقد رأيت وفهمت بوضوح تغطية السياسة والاستثناءات كما هو موضح في"}<span style={{cursor:'pointer',color:'#0d6efd',textDecoration:'underline'}} onClick={()=>openDoc('table-of-benefits')}>{lnstr=="en"?<u>Table of Benefits</u>:<u>جدول الفوائد</u>}</span> {lnstr=="en"?"I have also understood the":"لقد فهمت أيضا"} <span style={{cursor:'pointer',color:'#0d6efd',textDecoration:'underline'}} onClick={()=>openDoc('network-list')}><u>{lnstr=="en"?"network of coverage":"شبكة التغطية"}</u></span>{ lnstr=="en"?"from the network list (linked)":"من قائمة الشبكة (المتصلة)"}
              
            </p>

            <p ><input type="checkbox" checked={isChecked1}
              onChange={handleCheckboxChange1} name="note" />
              {lnstr=="en"?"I have read and understood":"لقد قرأت وفهمت"}  <span style={{cursor:'pointer',color:'#0d6efd',textDecoration:'underline'}} onClick={()=>openDoc('covid-19-terms-and-conditions')}><u>{lnstr=="en"?"Covid 19 coverage terms and condition":"شروط وأحكام تغطية كوفيد-19"}</u></span>
            </p>

            <p ><input type="checkbox" checked={isChecked2}
              onChange={handleCheckboxChange2} name="note" />
             {lnstr=="en"?"I have read and understood":"لقد قرأت وفهمت"}    <span style={{cursor:'pointer',color:'#0d6efd',textDecoration:'underline'}} onClick={()=>openDoc('policy-exclusion')}><u>{lnstr=="en"?"policy exclusions":"استثناءات السياسة"}
              </u></span>
            </p>

            <div className='col-md-2 text-center'>
              <button type="button" 
                style={{ backgroundColor: isChecked ? '#1D3561' : "grey", borderColor: '#1D3561' }}
                className="btn btn-primary rounded-pill text-white my-3 py-1 "
                // disabled={isChecked ? false : true}
                onClick={async () => {


                  var question_valid = !questionsData.some(q => q.isChecked_answer === '');
                  const wrongAnswerQuestion = questionsData.findIndex(q => q.isChecked_answer !== '' && q.isChecked_answer !== q.accepted_answer);
                  if (!question_valid) {
                    alert('Please ensure the question answer');
                  } else if (wrongAnswerQuestion !== -1) {
                    alert(`Please select the Answer ${questionsData[wrongAnswerQuestion].accepted_answer} in question ${wrongAnswerQuestion + 1}`);
                  } else if (signatureRef.current.isEmpty()) {
                    alert('Please put signature');
                  } else if (!isChecked) {

                    alert('Please ensure the declare');
                  } else if (!isChecked1) {

                    alert('Please ensure the declare');
                  } else if (!isChecked2) {

                    alert('Please ensure the declare');
                  } else {
                    debugger
                    // event.preventDefault();



                    setLoading(true);

                    await handleQotation();
                    
                    
                    // setPersonalPolicyData(null);
                    // setPersonalPolicyPaymentLink(null);
                    // await getQuotation(accessTokenKey);
                  }

                }}
              >
                {t("Proceed")}
              </button>
            </div>

            </Col>


            <Col md={3}></Col>

          </div>

        </div>
      </div>

      <Footer />

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}

    </Fragment>
  );
}

export default MedicalHealthQuestions;
